/**
 * Published DOM contract between carousel slides and `Carousel` chevron alignment.
 *
 * Set on `Tile` by default. `Carousel` reads it only when `chevronAlign="tile"` (media with a
 * caption sibling below). Media-only carousels (portrait rails, avatars) keep the default
 * `chevronAlign="container"` and ignore this attribute.
 */
export const CAROUSEL_MEDIA_ATTR = 'data-vds-carousel-media';

export const CAROUSEL_MEDIA_SELECTOR = `[${CAROUSEL_MEDIA_ATTR}]`;
